import {
  CircularProgress,
  ListItemIcon,
  Typography,
  useTheme,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReleaseIcon } from 'assets/icons';
import { selectReleaseRequest } from 'services/store/distribution/selectors';
import { StyledMenuItem } from '../../SongActionsMenu/components/styled';

type PropsType = {
  songId: string;
};

const ReleaseMenuButton = ({ songId }: PropsType) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const releaseRequest = useSelector(selectReleaseRequest(songId));
  const isLoading = releaseRequest?.loading;

  return (
    <StyledMenuItem>
      <ListItemIcon>
        {isLoading ? (
          <CircularProgress
            sx={{ color: theme.palette.grey[50] }}
            size={theme.spacing(2.5)}
          />
        ) : (
          <ReleaseIcon />
        )}
      </ListItemIcon>
      <Typography>{t('distribution:tooltip:distribute')}</Typography>
    </StyledMenuItem>
  );
};

export default ReleaseMenuButton;
